import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { getAuthToken } from "../../utils/auth";
import { handleApiError } from "../handleApiError";

const API_URL = process.env.REACT_APP_API_URL;

// Create
export const createComment = createAsyncThunk(
  "comment/create",
  async (data, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.post(`${API_URL}/comment/`, data, {
        headers: { Authorization: `${token}` },
      });
      // toast.success("Comment added");
      // console.log(res.data);
      return res.data.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Update
export const updateComment = createAsyncThunk(
  "comment/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.put(`${API_URL}/comment/${id}`, data, {
        headers: { Authorization: `${token}` },
      });
      return res.data.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Delete
export const deleteComment = createAsyncThunk(
  "comment/delete",
  async (id, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      await axios.delete(`${API_URL}/comment/${id}`, {
        headers: { Authorization: `${token}` },
      });
      return id;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Admin
export const getAllCommentsAdmin = createAsyncThunk(
  "comment/admin/all",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${API_URL}/comment/admin/all`, {
        headers: { Authorization: `${token}` },
      });
      return res.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
